<template>
  <BaseNew
    @new-confirm-action="createEntry"
    @new-cancel-action="resetForm"
    @new-open-action="loadServerEntry"
    @clear-form-errors="clearFormErrors"
    ref="baseNew"
    width="80%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :modelNameSingular="modelNameSingular"
    :inlineAddButton="inlineAddButton"
    addButtonIcon="mdi-handshake"
    :newCreateButtonLabel="newCreateButtonLabel"
    :newSaveButtonLabel="newSaveButtonLabel"
    :useModelInsteadOfButton="useModelInsteadOfButton"
  >
    <template slot="newForm">
      <Form
        ref="form"
        :entry="entry"
        :extraData="extraData"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseNew>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseNew from "@shared_components/base_new.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      entry: null,
      formErrors: [],
      extraData: null,
    };
  },
  props: {
    useModelInsteadOfButton: {
      type: Boolean,
      default: false
    },
    saleOrder: {
      default: null,
      type: Object
    },
    cropLotIds: {
      type: Array,
      default: () => new Array
    },
    inlineAddButton: {
      default: false,
      type: Boolean
    },
    newCreateButtonLabel: {
      type: String,
      default: "Adicionar Venda"
    },
    newSaveButtonLabel: {
      type: String,
      default: "Criar Venda"
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseNew: BaseNew
  },
  methods: {
    loadServerEntry: function() {
      this.error = null;
      this.loading = true;
      if (this.saleOrder) {
        this.$apollo
          .query({
            query: LOAD_NEW_SALE_FROM_SALE_ORDER_QUERY, 
            fetchPolicy: "no-cache",
            variables: {
              saleOrderId: this.saleOrder.id
            }
          })
          .then(response => {
            this.entry = response.data.accountContext.saleFromSaleOrder;
            this.extraData = response.data;
            
            // console.log("sale entry", this.entry)
            if (this.entry.initializationErrors.length){
              this.formErrors = this.entry.initializationErrors;
            }
          })
          .catch(response => console.log(response))
          .finally(() => (this.loading = false));
      }else if(this.cropLotIds.length>0){
         this.$apollo
          .query({
            query: LOAD_NEW_SALE_FROM_CROP_LOTS_QUERY, 
            fetchPolicy: "no-cache",
            variables: {
              cropLotIds: this.cropLotIds
            }
          })
          .then(response => {
            this.entry = response.data.accountContext.saleFromCropLots;
            this.extraData = response.data;
            
            // console.log("sale entry", this.entry)
            if (this.entry.initializationErrors.length){
              this.formErrors = this.entry.initializationErrors;
            }
          })
          .catch(response => console.log(response))
          .finally(() => (this.loading = false));
      }else {
        this.$apollo
          .query({
            query: LOAD_NEW_SALE_QUERY,
            fetchPolicy: "no-cache"
          })
          .then(response => {
            this.entry = response.data.accountContext.sale;
            this.extraData = response.data;

            this.extraData.customerId = this.entry.customerId;
            this.extraData.paymentConditionRuleId = this.entry.paymentConditionRuleId;
            // this.extraData.accountContext.accountPermissions = this.entry.accountContext.accountPermissions;
          })
          .catch(response => console.log(response))
          .finally(() => (this.loading = false));
      }
      

    },
    createServerEntry: function(sale) {
      // console.log("SALE", sale, sale.validations, this.deepFilterEntryWithAllowedFieldsForMutation(sale, sale.validations));
      this.pageLoading = true;
      this.$apollo
        .mutate({
          mutation: CREATE_SALE_MUTATION,
          variables: {
            input: this.deepFilterEntryWithAllowedFieldsForMutation(sale, sale.validations)
          }
        })
        .then(response => {
          var errors = response.data.createSale.errors

          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseNew.closeDialog();
            this.$emit("entry-created");
            this.resetForm();
          }
        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError){
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors){
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false));
    },
    createEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.createServerEntry(this.entry);
      }
    },
    resetForm: function() {
      if (this.$refs.form) {
        this.$refs.form.resetFormInputs();
      }
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

const LOAD_NEW_SALE_QUERY = gql `
  {
    accountContext {
      sale {
        id
        code
        billDate
        estimatedDeliveryDate
        fiscalDocumentType
        orderValidity
        customerId
        customerId
        totalPrice
        observation
        validations
        volume
        netWeight
        grossWeight
        specie
        brand        
        carrierId
        carrier {
          id
        }
        carriageModalityId
        carriageModality {
          id
        }
        carrierPatrimonyId
        carrierPatrimony {
          id
        }
        carrierLicensePlate
        carrierLicensePlateStateId
        totalCarriageValue
        totalDiscountValue
        totalInsuranceValue
        otherExpensesTotalValue
        dummyExitMovementItemsAttributes {
          id
          unitPrice
          quantity
          packagingQuantity
          packagingUnitName
          packagingPrice
          itemId
          storageId
          price
          item {
            id
            name
            description
            unit {
              name
            }
          }
          storage {
            id
            name
          }
        }
        paymentsAttributes {
          id
          code
          bankAccountId
          paymentMethodId
          value
          initialDate
          installmentsInterval {
            id
          }
          paymentConditionId
          paymentCondition {
            id
            description
            numberOfInstallments
          }
          paymentMethod {
            id
            name
          }
          bankAccount {
            id
            name
          }
          installmentsAttributes {
            id
            value
            originalValue
            customCode
            dueDate
            code
            status
            statusKey
            statusColor
            paidAmount
            paymentDate
            bankAccount {
              id
              name
            }
          }
        }
      }
      allPaymentConditionRules{
        id
        name
      }
      accountPermissions{
        isAltavenda
      }
      allCustomers {
        id
        name
      }
      allCarriers {
        id
        name
      }
      allCfops{
        id
        text
      }
    }
    globalContext {
			allPaymentConditions {
        id
        description
        numberOfInstallments
      }
      allCarriageModalities {
        id
        text
      }
      allStates {
        id
        shortName
      }
    }
  }
`;

const LOAD_NEW_SALE_FROM_SALE_ORDER_QUERY = gql `
  query ($saleOrderId: ID!) {
    accountContext {
      saleFromSaleOrder(saleOrderId: $saleOrderId) {
        id
        code
        date
        billDate
        initializationErrors
        estimatedDeliveryDate
        fiscalDocumentType
        orderValidity
        customerId
        totalPrice
        observation
        saleOrderId
        validations
        volume
        netWeight
        grossWeight
        specie
        brand
        carrierId
        carrier {
          id
        }
        carriageModalityId
        carriageModality {
          id
        }
        carrierPatrimonyId
        carrierPatrimony {
          id
        }
        carrierLicensePlate
        carrierLicensePlateStateId
        totalCarriageValue
        totalDiscountValue
        totalInsuranceValue
        otherExpensesTotalValue
        paymentConditionRuleId
        dummyExitMovementItemsAttributes {
          id
          price
          itemWeight{
            liquidWeight
            grossWeight
          }
          dummyExitMovementItemLotsAttributes{
            manufacturingLotId
            quantity
            packagingQuantity
            name
          }
          quantity
          itemId
          storageId
          unitPrice
          discount
          packagingQuantity
          packagingPrice
          packagingUnitName
          item {
            id
            name
            description
            unit {
              name
            }
            packagings {
              id
              name
              basicUnitName
              size
              text
            }
          }
          storage {
            id
            name
          }
          packagingId
          packaging {
            id
            name
            size
            text
          }
        }
        paymentsAttributes {
          id
          code
          bankAccountId
          paymentMethodId
          value
          initialDate
          installmentsInterval {
            id
          }
          paymentConditionId
          paymentCondition {
            id
            description
            numberOfInstallments
          }
          paymentMethod {
            id
            name
          }
          bankAccount {
            id
            name
          }
          installmentsAttributes {
            id
            value
            originalValue
            customCode
            dueDate
            code
            status
            statusKey
            statusColor
            paidAmount
            paymentDate
            bankAccount {
              id
              name
            }
          }
        }
      }
      allPaymentConditionRules{
        id
        name
      }
      accountPermissions{
        isAltavenda
      }
      allCustomers {
        id
        name
      }
      allCarriers {
        id
        name
      }
      allCfops{
        id
        text
      }
    }
    globalContext {
			allPaymentConditions {
        id
        description
        numberOfInstallments
      }
      allCarriageModalities {
        id
        text
      }
      allStates {
        id
        shortName
      }
    }
  }
`;

const LOAD_NEW_SALE_FROM_CROP_LOTS_QUERY = gql `
  query ($cropLotIds: [ID!]!) {
    accountContext {
      saleFromCropLots(cropLotIds: $cropLotIds) {
        id
        code
        date
        billDate
        initializationErrors
        estimatedDeliveryDate
        fiscalDocumentType
        orderValidity
        customerId
        totalPrice
        observation
        saleOrderId
        validations
        volume
        netWeight
        grossWeight
        specie
        brand
        carrierId
        carrier {
          id
        }
        carriageModalityId
        carriageModality {
          id
        }
        carrierPatrimonyId
        carrierPatrimony {
          id
        }
        trailerId
        trailer{
          id
          description
        }
        carrierLicensePlate
        carrierLicensePlateStateId
        totalCarriageValue
        totalDiscountValue
        totalInsuranceValue
        otherExpensesTotalValue
        dummyExitMovementItemsAttributes {
          id
          price
          quantity
          itemId
          discount
          totalDiscount
          liquidPrice
          storageId
          unitPrice
          packagingQuantity
          packagingPrice
          packagingUnitName
          dummyExitMovementItemLotsAttributes{
            manufacturingLotId
            name
            quantity
          }
          item {
            id
            name
            description
            unit {
              name
            }
            packagings {
              id
              name
              basicUnitName
              size
              text
            }
          }
          storage {
            id
            name
          }
          packagingId
          packaging {
            id
            name
            size
            text
          }
        }
        paymentsAttributes {
          id
          code
          bankAccountId
          paymentMethodId
          value
          initialDate
          installmentsInterval {
            id
            description
          }
          paymentConditionId
          paymentCondition {
            id
            description
            numberOfInstallments
          }
          paymentMethod {
            id
            name
          }
          bankAccount {
            id
            name
          }
          installmentsAttributes {
            id
            value
            originalValue
            customCode
            dueDate
            code
            status
            statusKey
            statusColor
            paidAmount
            paymentDate
            bankAccount {
              id
              name
            }
          }
        }
      }
      allPaymentConditionRules{
        id
        name
      }
      allCustomers {
        id
        name
      }
      accountPermissions{
        isAltavenda
      }
      allCarriers {
        id
        name
      }
      allCfops{
        id
        text
      }
    }
    globalContext {
			allPaymentConditions {
        id
        description
        numberOfInstallments
      }
      allCarriageModalities {
        id
        text
      }
      allStates {
        id
        shortName
      }
    }
  }
`;

const CREATE_SALE_MUTATION = gql `
  mutation($input: SaleCreateInputObject!) {
    createSale(input: $input) {
      cashFlow {
        id
      }
      errors
    }
  }
`;

</script>

<style scoped></style>
